import styles from './RangeBox.css'
import moment from 'moment'

class RangeBox extends React.Component {
  buttonOptions = [
    {id: '1_week', name: '1 Week'},
    {id: '2_weeks', name: '2 Weeks'},
    {id: '3_weeks', name: '3 Weeks'},
    {id: '1_month', name: '1 Month'},
    {id: '3_months', name: '3 Months'},
    {id: '6_months', name: '6 Months'},
    {id: '1_year', name: '1 Year'}
  ]

  render () {
    return (<div className={styles.wrapper}>
      {this.buttonOptions.map(({id, name}) => {
        return (<div className={`row ${styles.row}`}>
          <button className='btn btn-default btn-block' onClick={(e) => { this._onClickButton(e, id) }}>{name}</button>
        </div>)
      })}
    </div>)
  }

  _onClickButton = (e, id) => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onChange)
    e.preventDefault()
    e.stopPropagation()

    let startDate = moment().add(1, 'days').startOf('day').toISOString()
    let endDate
    switch (id) {
      case '1_week':
        endDate = moment().add({weeks: 1}).endOf('day').toISOString()
        break
      case '2_weeks':
        endDate = moment().add({weeks: 2}).endOf('day').toISOString()
        break
      case '3_weeks':
        endDate = moment().add({weeks: 3}).endOf('day').toISOString()
        break
      case '1_month':
        endDate = moment().add({months: 1}).endOf('day').toISOString()
        break
      case '3_months':
        endDate = moment().add({months: 3}).endOf('day').toISOString()
        break
      case '6_months':
        endDate = moment().add({months: 6}).endOf('day').toISOString()
        break
      case '1_year':
        endDate = moment().add({years: 1}).endOf('day').toISOString()
        break
    }
    this.props.onChange({startDate, endDate})
  }
}

RangeBox.propTypes = {
  onChange: React.PropTypes.func
}
export default RangeBox



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownCalendarPromo/RangeBox/RangeBox.js